import { useGetSectionDataQuery } from 'API/order/fees/FeeApi';
import React from 'react';
import { useSelectCurrentOrderId } from 'selectors/order/selectCurrentOrder';
import { OptionalLinkTW } from 'tailwindComponents/link/OptionalLinkTW';
import { eFeePropertyNames } from 'types/order/fees/eFeePropertyNames';
import { clientUrls } from 'ui-toolkit/rest/ClientUrlFactory';
import { assertDefined } from 'utilities/Assertions';

export const FeeInformation: React.FC<{ id: string }> = ({ id }) => {
  const orderId = useSelectCurrentOrderId();
  assertDefined(orderId);
  const { data } = useGetSectionDataQuery(orderId);
  const section = data?.find(
    (section) =>
      section.statementSettlementItems?.find(
        (lineItem) => lineItem.statementFees.find?.((fee) => fee.disbursementIds?.includes(id))
      )
  );
  const lineItem = section?.statementSettlementItems?.find(
    (lineItem) => lineItem.statementFees.find?.((fee) => fee.disbursementIds?.includes(id))
  );
  const lineItemName = lineItem?.stringSettlementStatementPropertyValues[eFeePropertyNames.Name];
  const tab = 'a-j';
  return (
    <OptionalLinkTW to={lineItem && clientUrls.urlFor.feesTabEdit(orderId, tab, lineItem?.settlementStatementItemId)}>
      {lineItemName}
    </OptionalLinkTW>
  );
};

export const FeeInformationColumn = {
  dataField: 'id',
  text: 'Fee Information',
  formatter: (id: any) => <FeeInformation id={id} />,
};
